export const QA_NAME_FORM_NOTIFICATIONS = 'formInlineNotifications'
